export default "__VITE_ASSET__656e9eaa__"